import script from "./RegisterComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterComponent.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterComponent.vue?vue&type=style&index=0&id=10b6224b&lang=css"

const __exports__ = script;

export default __exports__